import { OfferingStatus } from '../../../graphql';
import { useOfferingSidePanel_OfferingQuery } from '../graphql';

export const useGetOfferingStatus = ({ offeringId }: { offeringId?: string }) => {
  const { data } = useOfferingSidePanel_OfferingQuery({
    variables: { offeringId: offeringId! },
    skip: !offeringId,
  });

  const [offering] = data?.publishedOfferings?.items ?? [];
  const isFiledOffering = offering?.status === OfferingStatus.Filed;

  return { isFiledOffering };
};
